<template>
  <div class="courseResourse">
    <div class="courseResourse_head" v-if="resourcesFrom == '1'">
      <span></span>
      <span>
        <el-select
          @change="postCollegeLists"
          v-model="categoryId"
          placeholder="全部分类"
          size="mini"
          clearable
          style="width: 147px"
          @clear="initPageTotal"
        >
          <el-option
            v-for="item in resourceDatas"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          @keyup.enter.native="postCollegeLists"
          @clear="initPageTotal"
          style="width: 190px"
          v-model="resourceName"
          size="mini"
          clearable
          suffix-icon="el-icon-search"
          placeholder="请输入名称"
        ></el-input>
      </span>
    </div>
    <div  style="height: calc(100vh - 100px) !important;flex: 1;position: relative;">
      <el-table
        :data="tableData"
        style="position: absolute"
        @row-click="rowClick"
        :height="`calc(100% - 80px)`"
        :cell-style="{ textAlign: 'left' }"
        :header-cell-style="{ textAlign: 'left' }"
      >
        <!--          :header-cell-style="{ background: '#2b2a33', color: '#ffffff' }"-->
        <el-table-column width="35">
          <template slot-scope="scope">
            <span v-if="resourcesFrom == '1'">
                 <el-radio
                   v-if="nodeKey === 'id'"
                   :label="scope.row.resourceId"
                   v-model="currentValue"
                 >&nbsp;
                </el-radio>
                <el-radio
                  v-if="nodeKey === 'url'"
                  :label="scope.row.downloadUrl"
                  v-model="currentValue"
                >&nbsp;
                </el-radio>
            </span>
            <span v-else>
                <el-radio
                  v-if="nodeKey === 'id'"
                  :label="scope.row.id"
                  v-model="currentValue"
                >&nbsp;
                </el-radio>
                <el-radio
                  v-if="nodeKey === 'url'"
                  :label="scope.row.originalAttaUrl"
                  v-model="currentValue"
                >&nbsp;
                </el-radio>
            </span>

          </template>
        </el-table-column>

        <el-table-column prop="name" label="素材名称">
          <template slot-scope="scope">
            <span
              v-if="scope.row.transcodeStatus == 2"
              style="color: red; padding-right: 5px;"
            >[转码中]</span>
            <span
              v-else-if="scope.row.transcodeStatus == 3"
              style="color: red; padding-right: 5px;"
            >[转码失败]</span>
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="uploadUserName" label="上传人" width="130" v-if="resourcesFrom == '1'"></el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" width="140" v-if="resourcesFrom == '1'" :sortable="true"></el-table-column>
         <el-table-column prop="createUseStr" label="上传人" width="130" v-if="resourcesFrom == '2'"></el-table-column>
        <el-table-column prop="createTime" label="上传时间" width="140" v-if="resourcesFrom == '2'"></el-table-column>
        <el-table-column label="操作" width="80" v-if="addType == 6">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="goCreatEditor(scope.row)"
              type="text"
              size="mini"
              :disabled="scope.row.isAuth == 0"
            >编辑
            </el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="empty_material">
          <!-- <img src="../../../assets/image/sources/wujieguo.png" alt="加载失败"/> -->
          <p>该课程暂无素材</p>
        </div>
      </el-table>
      <Pagination
        style="position: absolute;bottom: 0;right: 0"
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
      ></Pagination>
    </div>
  </div>
</template>
<script>
  import * as api from "../../api/sourceApi";
  import Pagination from "@/components/paginator/paginator";
  import * as sourceApi from "../../api/sourceApi";

  import bus from "@/vendor/eventbus";
  export default {
    name: "courseResourse.vue",
    props: {
      value: {
        type: [String, Number],
        default: "",
      },
      subjectId: {
        type: [String, Number],
        default: 0,
      },
      courseId: {
        type: [String, Number],
        default: 0,
      },
      resourcesFrom: {  // 1课程资源  2 总资源库
        type: String,
        default: '1',
      },
      type: {
        type: [String, Number],
        default: -1,
      },
      addType: {
        type: [String, Number],
        default: -1,
      },
      // 默认获取选中的ID， 传入url会返回选中项的url
      nodeKey: {
        type: String,
        default: "id",
      },
    },
    components: {
      Pagination,
    },
    data() {
      return {
        //  { 2021.7.8
        tableData: [],
        isHave: true, // 是否拥有想要的素材。没有就本地上传
        materialId: null,
        // 2021.7.9
        currentValue: this.value,
        categoryId: "",
        resourceDatas: [],
        resourceName: "",
        //分页数据
        pageTotal: {
          currentPage: 1,
          pageSize: 10,
          total: 0,
        },
        courseModel: this.$route.query.courseModel || '', // 产品模式 1标准 2产品
      };
    },
    watch: {
      value(val) {
        this.currentValue = val;
      },
      currentValue(val) {
        this.$emit("input", val);
      },
      type(val) {
        this.pageTotal = {
          currentPage: 1,
          pageSize: 10,
          total: 0,
        };
        this.postCollegeLists();
      },
      addType() {
        this.pageTotal = {
          currentPage: 1,
          pageSize: 10,
          total: 0,
        };
        this.postCollegeLists();
      },
      resourcesFrom() {
        this.pageTotal = {
          currentPage: 1,
          pageSize: 10,
          total: 0,
        };
        this.postCollegeLists();
      },
    },
    computed: {},
    created() {
      // bus.$on("resourseInit", this.postCollegeLists);
      this.findResCategoryByCourseId();
      this.postCollegeLists();
      console.log(this.type, this.nodeKey);
    },
    mounted() {},
    methods: {
      //添加试题  注释掉 wjl  2022.4.22
      // addQues() {
      //   let type = -1;
      //   if (this.type > -1) {
      //     type = this.type == 7 ? 7 : 4;
      //   } else if (this.addType > -1) {
      //     type = this.addType;
      //   }
      //   this.$emit('addQues', type)
      // },
      // uploadFile() {
      //   this.$emit('changeMaterialDialogVisible')
      // },
      // 素材列表数据
      postCollegeLists() {
        this.tableData = [];
        let type = -1;
        if (String(this.resourcesFrom) === '1') {
          if (this.type > -1) {
            type = this.type == 7 ? 7 : this.type == 5 ? 5 : this.type == 110 ? 1 : 4;
          } else if (this.addType > -1) {
            type = this.addType;
          }
          let obj = {
            pageNum: this.pageTotal.currentPage,
            pageSize: this.pageTotal.pageSize,
            categoryId: this.categoryId, //课程id
            courseId: this.courseId, //课程id
            fileType: type, //文件类型（1ppt，7图片，2文档, 3音频，4视频，5链接，6图文，7其它）
            name: this.resourceName, //资源名称
          };
          api
            .getResoureceByCourseId(obj)
            .then((res) => {
              if (res.code == "0") {
                if (res.data && res.data.list && res.data.list.length > 0) {
                  this.tableData = res.data.list;
                  let {total, pageNum: currentPage, pageSize} = res.data;
                  this.pageTotal = {total, currentPage, pageSize};
                } else {
                  this.pageTotal = {currentPage: 1, pageSize: 10};
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });

        } else if (this.resourcesFrom == '2') {
          let obj = {
            pageNum: this.pageTotal.currentPage,
            pageSize: this.pageTotal.pageSize,
            newType: this.addType,
            subjectId: this.subjectId,
          };
          api
            .getMaterialList(obj, {
              method: "post",
            }).then((res) => {
            if (res.code == "0") {
              if (res.data && res.data.list && res.data.list.length > 0) {
                this.tableData = res.data.list;
                let {total, pageNum: currentPage, pageSize} = res.data;
                this.pageTotal = {total, currentPage, pageSize};
              } else {
                this.pageTotal = {currentPage: 1, pageSize: 10};
              }
            }
          })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      filtersType(type) {
        switch (type) {
          case 7:
            return 1;
          case 8:
            return 2;
          case 10:
            return 4;
          default:
            return "";
            break;
        }
      },
      // 查询资源分类
      findResCategoryByCourseId() {
        sourceApi
          .FindResCategoryByCourseId(this.courseId)
          .then((res) => {
            if (res.code == "0") {
              this.resourceDatas = res.data;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      handleCurrentChange(val) {
        this.pageTotal.currentPage = val || this.pageTotal.currentPage;
        this.postCollegeLists();
      },
      handleSizeChange(val) {
        this.pageTotal.pageSize = val;
        this.pageTotal.currentPage = 1;
        this.postCollegeLists();
      },
      goCreatEditor(row) {
        if (this.resourcesFrom === '1'){
          this.$router.push({
            path: '/creatEditor',
            query: {
              subjectId: this.subjectId,
              courseId: this.courseId,
              id: row.categoryResourceId,
              resourceId: row.resourceId,
              resourcesFrom: this.resourcesFrom,
              courseModel: this.courseModel,
            }
          })
        }else if (this.resourcesFrom === '2'){
          this.$router.push({
            path: '/creatEditor',
            query: {
              subjectId: this.subjectId,
              courseId: this.courseId,
              id: row.id,
              resourcesFrom: this.resourcesFrom,
              courseModel: this.courseModel,
            }
          })
        }

      },
      rowClick(row) {
        if (this.resourcesFrom == '1') {
          if (this.nodeKey === "id") {
            this.currentValue = row.resourceId;
          } else if (this.nodeKey === "url") {
            this.currentValue = row.downloadUrl;
          }
        } else {
          if (this.nodeKey === "id") {
            this.currentValue = row.id;
          } else if (this.nodeKey === "url") {
            this.currentValue = row.originalAttaUrl;
          }
        }

        this.$emit('hhdTeacher', row);
      },
      initPageTotal() {
        this.$set(this.pageTotal, "currentPage", 1);
      },
    },
  };
</script>
<style scoped lang="scss">
  .courseResourse {
    height: 100%;
    width: 100%;
    color: #2b2a33;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .courseResourse_head {
      padding: 15px 0;
      display: flex;
      justify-content: space-between;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/component/courseResourse.vue